const ImageTag = (props) => {
  const { path, classes, altText } = props;

  return (
    <img
      src={path}
      className={`${classes}`}
      alt={altText}
      // onLoad={handleImageLoad}
      // onError={handleImageError}
    />
  );
};

export default ImageTag;
